'use client'

import { useEffect, useState } from 'react'
import Calendar from './calendar'
import { Mode } from '@/components/calendar/calendar-types'
import { CalendarLocation, CalendarPartner, CalendarVehicle, CalendarEvent, ReservationState } from './calendar-types'
import { getCommissionPartners, getLocations, getReservations, getReservationStates, getVehicles } from '@/rental/services/reservation-service'
import { useUserContext } from '@/context/UserContext'

export default function ReservationCalendar() {
  const [events, setEvents] = useState<CalendarEvent[]>([])
  const [mode, setMode] = useState<Mode>('month')
  const [date, setDate] = useState<Date>(new Date())
  const [locations, setLocations] = useState<CalendarLocation[]>([]);
  const [partners, setPartners] = useState<CalendarPartner[]>([]);
  const [vehicles, setVehicles] = useState<CalendarVehicle[]>([]);
  const [reservationStates, setReservationStates] = useState<ReservationState[]>(getReservationStates());

  const { decodedToken } = useUserContext();

  useEffect(() => {
    const unsub = async () => {
      if (decodedToken?.user.id) {
        setLocations(await getLocations());
        setVehicles(await getVehicles());
        setPartners(await getCommissionPartners());
      }      
    }
    unsub();
  }, [decodedToken?.user.id])

  // reload events when the date or mode changes
  useEffect(() => {
    const unsub = async () => {
      // convert date and mode to a date interval
      const startDate = new Date(date);
      const endDate = new Date(date);
      if (mode === 'month') {
        // set to the start of the month
        startDate.setDate(1);
        startDate.setHours(0, 0, 0, 0);
        endDate.setMonth(endDate.getMonth() + 1);
        endDate.setDate(0); // last day of the month
        endDate.setHours(23, 59, 59, 999);
      } else if (mode === 'week') {
        // set to the start of the week
        const day = startDate.getDay();
        const diff = startDate.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
        startDate.setDate(diff);
        endDate.setDate(diff + 6);
      } else if (mode === 'day') {
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 999);
      }

      const reservations = await getReservations(startDate, endDate);
      setEvents(reservations);
    }
    unsub();
  }, [date, mode]);
  

  return (
    <>
      <Calendar
        events={events}
        setEvents={setEvents}
        mode={mode}
        setMode={setMode}
        date={date}
        setDate={setDate}
        vehicles={vehicles}
        setVehicles={setVehicles}
        locations={locations}
        setLocations={setLocations}
        partners={partners}
        setPartners={setPartners}
        reservationStates={reservationStates}
        setReservationStates={setReservationStates}
      />
    </>
  )
}
